import { Typography } from "@mui/material";
import CardBox from "../../../../main/components/CardBox";

export type RecentEventsProps = {
    text: string;
    hour: string;
    status: "warning" | "danger";
}

export default function RecentEvents(props: RecentEventsProps) {
    const { text, hour, status } = props

    function getColorByStatus() {
        switch (status) {
            case "warning":
                return "#ff98001c";
            case "danger":
                return "#f4433617";
            default:
                return null;
        }
    }

    function getBorderByStatus() {
        switch (status) {
            case "warning":
                return "1px solid #FF9800";
            case "danger":
                return "1px solid #F44336";
            default:
                return "1px solid #8F969E";
        }
    }

    return (
        <CardBox sx={{ marginBottom: "8px", borderRadius: "8px", border: getBorderByStatus(), width: "100%", height: "auto", justifyContent: "space-between", padding: "12px", backgroundColor: getColorByStatus() }}>
            <Typography sx={{ fontWeight: "300", fontSize: "14px", textAlign: "start" }}>{text}</Typography>
            <Typography sx={{ fontWeight: "400", fontSize: "12px", textAlign: "start", color: "#8F969E", marginRight: "8px" }}>{hour}</Typography>
        </CardBox>
    )
}